import { render, staticRenderFns } from "./PriceListItemEdit.vue?vue&type=template&id=65be8b8e&"
import script from "./PriceListItemEdit.vue?vue&type=script&lang=js&"
export * from "./PriceListItemEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports